/**
 * @generated SignedSource<<372213bdfcbca28794f9d4797ca4fe20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hooksUsePlusHomePageUpdateIndicatorQuery$variables = Record<PropertyKey, never>;
export type hooksUsePlusHomePageUpdateIndicatorQuery$data = {
  readonly dailyPulse: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly publishedDate: number | null | undefined;
      };
    }>;
  };
  readonly highlightQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly publishedDate?: number | null | undefined;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly opinionQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly publishedDate?: number | null | undefined;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type hooksUsePlusHomePageUpdateIndicatorQuery = {
  response: hooksUsePlusHomePageUpdateIndicatorQuery$data;
  variables: hooksUsePlusHomePageUpdateIndicatorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v1 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "typeIds": [
        "517498"
      ]
    }
  },
  (v0/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      {
        "direction": "DESC",
        "field": "PUBLISHED_DATE"
      }
    ]
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "scmp_plus_featured_opinion"
    }
  }
],
v5 = [
  (v0/*: any*/)
],
v6 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "Content",
  "abstractKey": "__isContent"
},
v7 = [
  {
    "alias": null,
    "args": (v5/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "items(first:1)"
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "scmp_plus_home_news"
    }
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": (v5/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "items(first:1)"
  },
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksUsePlusHomePageUpdateIndicatorQuery",
    "selections": [
      {
        "alias": "dailyPulse",
        "args": (v1/*: any*/),
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Article",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "articles(filter:{\"typeIds\":[\"517498\"]},first:1,orderBy:[{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"}])"
      },
      {
        "alias": "opinionQueue",
        "args": (v4/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"scmp_plus_featured_opinion\"})"
      },
      {
        "alias": "highlightQueue",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v7/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"scmp_plus_home_news\"})"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "hooksUsePlusHomePageUpdateIndicatorQuery",
    "selections": [
      {
        "alias": "dailyPulse",
        "args": (v1/*: any*/),
        "concreteType": "ArticleConnection",
        "kind": "LinkedField",
        "name": "articles",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArticleEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Article",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "articles(filter:{\"typeIds\":[\"517498\"]},first:1,orderBy:[{\"direction\":\"DESC\",\"field\":\"PUBLISHED_DATE\"}])"
      },
      {
        "alias": "opinionQueue",
        "args": (v4/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v10/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"scmp_plus_featured_opinion\"})"
      },
      {
        "alias": "highlightQueue",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v10/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"scmp_plus_home_news\"})"
      }
    ]
  },
  "params": {
    "cacheID": "d66640a8416e2917733ab760e121ab25",
    "id": null,
    "metadata": {},
    "name": "hooksUsePlusHomePageUpdateIndicatorQuery",
    "operationKind": "query",
    "text": "query hooksUsePlusHomePageUpdateIndicatorQuery {\n  dailyPulse: articles(filter: {typeIds: [\"517498\"]}, first: 1, orderBy: [{field: PUBLISHED_DATE, direction: DESC}]) {\n    edges {\n      node {\n        publishedDate\n        id\n      }\n    }\n  }\n  opinionQueue: queue(filter: {name: \"scmp_plus_featured_opinion\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            publishedDate\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  highlightQueue: queue(filter: {name: \"scmp_plus_home_news\"}) {\n    items(first: 1) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            publishedDate\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2384aaa4160635801770e058a9951351";

export default node;
